import * as React from 'react';

import Lightbox from 'components/lightbox';
import { Icon, ICON_NAME } from 'components/icon';
import { IStepsDescriptionRewardProps } from '../steps-description.types';
import { ITranslationProps } from 'types/translation';

import defaultRewardsImage from '../assets/rewards-placeholder.png';
import TEXT_KEYS from '../step-description.constants';
import './step-description-reward.styles.less';

class StepsDescriptionReward extends React.Component<ITranslationProps & IStepsDescriptionRewardProps> {
    public openLightbox = () => {
        this.props.showRewardsImageLightbox(true);
    };

    public closeLightbox = () => {
        this.props.showRewardsImageLightbox(false);
    };

    private getImageSrc = (): string => {
        return this.props.imageSrc || defaultRewardsImage;
    };

    public getLightbox = (): React.ReactNode => {
        const closeBtn = (
            <button
                type="button"
                className="sitegen-fr-steps-description-reward__button sitegen-fr-steps-description-reward__button--close"
                onClick={ this.closeLightbox }
            >
                <Icon name={ICON_NAME.CLOSE} />
            </button>
        );

        return this.props.isLightboxOpen
            ?   <Lightbox
                mainSrc={ this.getImageSrc()  }
                onCloseRequest={ this.closeLightbox }
                toolbarButtons={ [closeBtn] }
            />
            : null;
    };

    public render() {
        const { dangerouslyTranslateWithHTML: translateKey } = this.props;
        return (
            <div className="sitegen-fr-steps-description-reward">
                <div className="sitegen-fr-steps-description-reward__title">
                    { translateKey(TEXT_KEYS.REWARDS) }
                </div>
                <div className="sitegen-fr-steps-description-reward__image-wrapper">
                    <img
                        className="sitegen-fr-steps-description-reward__image"
                        src={ this.getImageSrc() }
                        alt=""
                    />
                    <button
                        type="button"
                        className="sitegen-fr-steps-description-reward__button sitegen-fr-steps-description-reward__button--glass"
                        onClick={ this.openLightbox }
                    >
                        <Icon
                            className="sitegen-fr-steps-description-reward-glass-icon"
                            name={ICON_NAME.GLASS}
                        />
                    </button>
                </div>

                <div className="sitegen-fr-steps-description-reward__subtitle">
                    { translateKey(TEXT_KEYS.SUBTITLE) }
                </div>

                { this.getLightbox() }
            </div>
        );
    }
}

export default StepsDescriptionReward;
export { Lightbox };
